import React from "react"
import styled from "styled-components"

const OurVision = () => {
  return (
    <Wrapper>   
      <div className="center">
      <h2>Our Vision</h2>
      <p>
        At Shopify Systems, we know how to create the ideal user experience.
        Stop wasting time with other companies who won’t do the work to get this
        right the first time. Our team of agents is well-versed in how to
        identify mistakes and combat them quickly so you can focus on your
        business. We are in the business of making stores that our customers can
        be proud of, and doing this as efficiently as possible.
      </p>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  margin: 100px 0;
  padding: 26px 20px;
  background: var(--clr-white);
  h2 { font-size: 30px; line-height: 47px; }
  p { font-size: 12px; line-height: 190%; }
  @media screen and (min-width: 360px) { padding: 25px 57px; }
  @media screen and (min-width: 768px) { padding: 25px 77px; }
  @media screen and (min-width: 1024px) { margin: 100px 129px; }
  @media screen and (min-width: 1025px) { 
    ${'' /* padding: 60px 9%; margin: 100px 0;       */}
    padding: 60px 0;
    margin:0;
    .center{      
      width: 90vw;
      margin: 0px auto;
      max-width: 1170px;
      h2 { font-size: 46px; line-height: 72px; }
      p { width: 582px; font-size: 14px; line-height: 190%; text-align: justify; }
      @media (min-width: 1180px) {width: 100%;}
    }
    
  }
  
`

export default OurVision
